import React from 'react'
import { useProfileManager } from '../hooks/useProfileManager'
import AvatarDisplay from './Profile/AvatarDisplay'
import StatusMessage from './UI/StatusMessage'

const ProfilePictureUpload = () => {
  const {
    profile,
    isUploading,
    error,
    success,
    handleFileSelect,
    handleIconSelect,
    handleRemovePicture,
    refreshProfile
  } = useProfileManager()

  return (
    <div className="space-y-4">
      <AvatarDisplay
        profile={profile}
        isUploading={isUploading}
        onFileSelect={handleFileSelect}
        onIconSelect={handleIconSelect}
        onRemovePicture={handleRemovePicture}
        onProfileUpdate={refreshProfile}
      />

      {error && <StatusMessage type="error" message={error} />}
      {success && <StatusMessage type="success" message={success} />}
    </div>
  )
}

export default ProfilePictureUpload